import Icon from "@react-native-vector-icons/material-design-icons";
import { Link, useRoute } from "@react-navigation/native";
import theme from "assets/theme";
import React, { useMemo } from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";
import { ScreenHeight } from "utils/screenDimensions.utils";

const classes = StyleSheet.create({
  backButtonIcon: {
    color: theme.color.grey,
  },
  buttonText: {
    color: theme.color.link,
    fontSize: theme.font.size.small,
    fontWeight: theme.font.weight.medium,
  },
  warningText: {
    color: theme.color.error,
    fontSize: theme.font.size.small,
    fontWeight: theme.font.weight.medium,
  },
  backButtonContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  textContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  text: {
    marginLeft: 5,
    marginRight: 5,
    fontSize: theme.font.size.small,
    color: theme.color.black,
  },
  icon: {
    paddingRight: 6,
  },
});

export default function CustomLink(props) {
  const {
    onPress,
    variant,
    text,
    linkText,
    navigateTo,
    warning,
    disabled,
    params,
  } = props;

  const linkStyle = useMemo(() => {
    if (disabled) {
      return {
        color: theme.color.disabled,
        fontSize: theme.font.size.small,
        fontWeight: theme.font.weight.medium,
      };
    } else if (warning) {
      return {
        color: theme.color.error,
        fontSize: theme.font.size.small,
        fontWeight: theme.font.weight.medium,
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      };
    } else {
      return {
        color: variant === "white" ? theme.color.white : theme.color.link,
        textDecoration: variant === "white" && "underline",
        fontWeight: theme.font.weight.medium,
      };
    }
  }, [disabled, warning, variant]);

  const currentRoute = useRoute();
  return (
    <Pressable onPress={onPress}>
      {variant !== "back" && (
        <View style={classes.textContainer}>
          {text && <Text style={classes.text}>{text}</Text>}
          <Link
            onPress={onPress}
            screen={navigateTo || currentRoute.name}
            params={params}
            numberOfLines={1}
          >
            <View style={linkStyle}>
              <View style={classes.icon}>
                {!!warning && (
                  <Icon
                    name="delete"
                    size={ScreenHeight * 0.025}
                    color={theme.color.error}
                  />
                )}
              </View>
              <Text style={linkStyle}>{linkText}</Text>
            </View>
          </Link>
        </View>
      )}
    </Pressable>
  );
}
